import madelynPic from "@/public/images/artists/madelyn.png";
import { Artist } from "@/types/types";

export const madelyn = {
  id: "146",
  name: "Madelyn",
  image: madelynPic,
  description: `Madelyn's voice strikes a unique balance between depth and lightness. It has a cinematic quality, filling the room with warmth while maintaining a delicate, airy texture. Her voice is ideal for soundtracks, effortlessly conveying both subtle emotions and sweeping narratives.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fmadelyn-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: [
        "Soundtrack",
        "Theatrical",
        "Ballads",
        "Unprocessed",
        "RnB",
        "Deep",
      ],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "High",
      },
      specific: {
        low: 55,
        high: 73,
      },
      sweetSpot: 65,
    },
  },
} as const satisfies Artist;
